import { H3, P2 } from '@repo/ui/components/Typography';
import { hideScrollBar } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled, { css } from 'styled-components';

import { Wrapper as CommentInputWrapper } from '../CommentBox/CommentInput/styles';
import { CommentsWrapper } from '../CommentList/styles';

export const Post = styled.div<{ isNewsfeed?: boolean }>`
  width: 100%;
  max-width: ${({ isNewsfeed }) => (isNewsfeed ? '660px' : '100%')};

  padding: 24px;
  border-radius: 5px;

  ${({ isNewsfeed }) =>
    isNewsfeed &&
    `
  padding: 0;
  padding-top: 12px;
  border-top: 1px solid ${themeStyle.varInkSuperLight};
    `}

  ${QUERIES.largeTabletAndUp} {
    padding: 24px;
    border: none;
  }

  overflow-y: scroll;
  ${hideScrollBar}
`;

export const Grid = styled.div<{
  isNewsfeed?: boolean;
}>`
  ${({ isNewsfeed }) =>
    !isNewsfeed &&
    `
  ${QUERIES.largeTabletAndUp} {
    display: grid;
    grid-template-columns: 1fr 270px;
    grid-template-rows: auto 1fr;
    grid-template-areas: 
      'actions author'
      'image information';
    grid-gap: 24px;
  }

  ${QUERIES.laptopAndUp} {
    grid-template-columns: 1fr 335px;
  }

  `}
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  position: relative;
  height: 100%;
  ${hideScrollBar}
`;

export const InformationWrapper = styled.div<{ isNewsfeed?: boolean }>`
  ${({ isNewsfeed }) => {
    if (isNewsfeed) {
      return '';
    }
    return css`
      ${QUERIES.largeTabletAndUp} {
        position: absolute;
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;

        ${Description} {
          overflow-y: auto;
          max-height: 120px;
        }

        ${CommentsWrapper} {
          flex: 1;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          height: 100%;

          ${CommentInputWrapper} {
            margin-top: auto;
          }
        }
      }
    `;
  }}
`;

export const Title = styled(H3).attrs(() => ({ as: 'h1' }))`
  overflow-wrap: break-word;
`;

export const Description = styled(P2)`
  margin-top: 10px;
  overflow-wrap: break-word;
`;

export const Close = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid ${themeStyle.varInkSuperLight};
  padding-bottom: 12px;
  margin-bottom: 12px;

  svg {
    transform: scaleX(-1);
  }

  ${QUERIES.largeTabletAndUp} {
    display: none;
  }
`;

export const NonGridSpacer = styled.div.attrs<{
  h?: string;
  isNewsfeed?: boolean;
}>(({ h }) => ({
  style: { height: h },
}))`
  display: block;

  ${QUERIES.largeTabletAndUp} {
    display: ${({ isNewsfeed }) => (isNewsfeed ? 'block' : 'none')};
  }
`;

export const MobileEditTemplateButtonWrapper = styled.div`
  padding: 24px 16px;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: ${themeStyle.zIndexS1};
  background-color: #ffffff;
  border-top-left-radius: ${themeStyle.radiusMedium};
  border-top-right-radius: ${themeStyle.radiusMedium};
  border-top: 1px solid ${themeStyle.varInkSuperLight};
  ${QUERIES.tabletAndUp} {
    display: none;
  }
`;
